export default function Excel_Color_Scales() {
  return <div>Excel_Color_Scales</div>;
}
